import ApiStore from 'shared/stores/ApiStore';
import { computed, observable } from 'mobx';

export default class TreeStore extends ApiStore {

  @observable lastSearchTerm = '';

  isInfoSupported = false;

  @computed
  get onDate() {
    return this.rootStore.appStore.onDate;
  }

  @computed
  get expandedNodes() {
    return this.rootStore.appStore.expandedNodes;
  }

  constructor() {
    super(...arguments);

    if (this.constructor === TreeStore)
      throw new Error('Tree Store must not be instantiated on its own');

    this.configure({
      domain: process.env.REACT_APP_API_DOMAIN,
      prefix: process.env.REACT_APP_API_PREFIX
    });
  }

  async fetchChildNodes(parentNode, type) {
    if (!type) throw new Error ('Record type must be defined');

    const query = { parent: parentNode ? parentNode.id : 0 }
    const url = this.buildUrl(type, { query });
    const nodes = await this.request(url);
    const items = this.nodes.set(nodes);
    return items;
  }

  async search(term, type) {
    if (!type) throw new Error ('Record type must be defined');

    this.lastSearchTerm = term;

    const query = { search: term };
    const url = this.buildUrl(type, { query });
    const nodes = await this.request(url);

    this.foundNodes.clear();
    return this.foundNodes.set(nodes);
  }

  async fetchParents(nodeId, type) {
    if (!type) throw new Error ('Record type must be defined');

    const query = { includeRecords: true };
    const id = nodeId;
    const action = 'path';
    const url = this.buildUrl(type, { id, action, query });
    const nodes = await this.request(url);

    return this.nodes.set(nodes);
  }

  async reload() {
    const { appStore } = this.rootStore;

    appStore.isTreeReady = false;
    if (this.widgetOrigin === null){
      this.widgetOrigin = appStore.widgetOrigin ? appStore.widgetOrigin : appStore.treeLink;
    }
    this.nodes.clear();
    await this.fetchChildNodes();
    await this.restoreTreeState();

    appStore.isTreeReady = true;
  }

  async restoreTreeState() {
    return await Promise.all(this.expandedNodes.map(this.restoreNodeBranch.bind(this)));
  }

  async restoreNodeBranch(nodeId) {
    const parents = await this.fetchParents(nodeId) || [];
    if (parents.length) {
      for (let i = 0; i < parents.length; i++) {
        const node = parents[i];
        if (node.parent) {
          node.parent.isExpanded = true;
          await node.parent.fetchChildNodes();
        }
        node.isExpanded = true;
        await node.fetchChildNodes();
      }
    } else {
      const node = this.nodes.find(node => node.id === +nodeId);
      if (node) {
        node.isExpanded = true;
        await node.fetchChildNodes();
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/stores/TreeStore.js